/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/367-pagebreak': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 6V0h12v6h-1V1H5v5zm12 3v7H4V9h1v6h10V9zM8 7h2v1H8zM5 7h2v1H5zm6 0h2v1h-2zm3 0h2v1h-2zM0 4.5l3 3-3 3z"/>'
  }
})
